import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../loader.service';
import { Tenant } from 'src/app/shared/models/tenant.model';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private http: HttpClient,
    private loaderSvc: LoaderService,
  ) {}

  public getPermissions(): Observable<string[]> {
    this.loaderSvc.activate();
    return this.http.get<string[]>(`${environment.apiHostUrl}/api/users/permissions`).pipe(tap(() => this.loaderSvc.deactivate()));
  }
}
